import type { ResponseValue, SaveAnswersResponse, SurveyDto } from '@genoma/shared';

import { get, patch, post, put } from './api.ts';

export const fetchCurrentSurvey = () => get<SurveyDto>('/surveys/current');

/**
 * How long a save may take before it counts as failed.
 *
 * Leaving a screen saves first and the screen does not change until that
 * returns, so a request that hangs rather than fails would hold the
 * questionnaire still — and the screen shows a moving indicator, not a button,
 * while it changes. A rater would be looking at a dead end.
 *
 * Losing the race costs nothing: the store puts a failed batch back and the
 * next save carries it, so an answer is written twice at worst, never lost.
 */
const SAVE_TIMEOUT_MS = 8000;

export const saveAnswers = (
  surveyId: string,
  answers: { evaluatedId: string; behaviorId: string; value: ResponseValue }[],
  position?: { behaviorNumber?: number; groupIndex?: number },
) =>
  patch<SaveAnswersResponse>(
    `/surveys/${surveyId}/answers`,
    { answers, position },
    AbortSignal.timeout(SAVE_TIMEOUT_MS),
  );

export const saveOpenComment = (surveyId: string, evaluatedId: string, text: string) =>
  put<void>(
    `/surveys/${surveyId}/comment`,
    { evaluatedId, text },
    AbortSignal.timeout(SAVE_TIMEOUT_MS),
  );

export const submitSurvey = (surveyId: string) =>
  post<{ answered: number; notObserved: number }>(`/surveys/${surveyId}/submit`);
